import { render } from "./CrossTab.vue?vue&type=template&id=e67c0bb6&scoped=true"
import script from "./CrossTab.vue?vue&type=script&lang=js"
export * from "./CrossTab.vue?vue&type=script&lang=js"

import "./CrossTab.vue?vue&type=style&index=0&id=e67c0bb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67c0bb6"]])

export default __exports__